import { NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomePageComponent } from './home-page/home-page.component';
import { RegistrationPageComponent } from './registration-page/registration-page.component';
import { SharedModule } from '../shared/shared.module';
import { StandardContentPageComponent } from './standard-content-page/standard-content-page.component';
import { GradesPageComponent } from './grades-page/grades-page.component';
import { MyGradesComponent } from './grades-page/my-grades/my-grades.component';
import { RecentlyAcceptedComponent } from './grades-page/recently-accepted/recently-accepted.component';
import { ExamsPageComponent } from './exams-page/exams-page.component';
import { LinksPageComponent } from './links-page/links-page.component';
import { RouterModule } from '@angular/router';
import { SchedulePageComponent } from './schedule-page/schedule-page.component';
import { CoursesCardComponent } from './schedule-page/courses-card/courses-card.component';
import { ExamsCalendarCardComponent } from './exams-page/exams-calendar-card/exams-calendar-card.component';
import { RegistrationTitleComponent } from './registration-page/registration-title/registration-title.component';
import { MessagesPageComponent } from './messages-page/messages-page.component';
import { DepartmentInfoPageComponent } from './department-info-page/department-info-page.component';
import { BillingAccountPageComponent } from './billing-account-page/billing-account-page.component';
import { DeanOfStudentsPageComponent } from './dean-of-students-page/dean-of-students-page.component';
import { CatalogPageComponent } from './catalog-page/catalog-page.component';
import { PortalPreviewPageComponent } from './portal-preview-page/portal-preview-page.component';
import { FormsModule } from '@angular/forms';
import { PortalMessagesPageComponent } from './portal-messages-page/portal-messages-page.component';

@NgModule({
  declarations: [
    HomePageComponent,
    RegistrationPageComponent,
    StandardContentPageComponent,
    GradesPageComponent,
    // MyGradesComponent,
    //RecentlyAcceptedComponent,
    ExamsPageComponent,
        LinksPageComponent,
	    SchedulePageComponent,
	        CoursesCardComponent,
	   ExamsCalendarCardComponent,
    RegistrationTitleComponent,
    MessagesPageComponent,
    DepartmentInfoPageComponent,
    BillingAccountPageComponent,
    DeanOfStudentsPageComponent,
    PortalMessagesPageComponent,
    CatalogPageComponent,
    PortalPreviewPageComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    FormsModule,
  ],
  exports: [
    HomePageComponent,
    RegistrationPageComponent,
    GradesPageComponent
  ]
 
})
export class PagesModule { }
